import { getStorage } from 'firebase/storage';
import initializeFirebase from '../../init';

const loadStorage = () => {
  initializeFirebase();
  return getStorage();
};

export default loadStorage();
